import { render } from "./BlModelExporter.vue?vue&type=template&id=e8773344&scoped=true"
import script from "./BlModelExporter.vue?vue&type=script&lang=js"
export * from "./BlModelExporter.vue?vue&type=script&lang=js"

import "./BlModelExporter.vue?vue&type=style&index=0&id=e8773344&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8773344"]])

export default __exports__